export default "__VITE_ASSET__BeKDHUuc__"